import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import NO_OUT_Component from "../NO_OUT_Component";
import {useUser} from "../../../Context/UserContext";
import StationElevationPlot from "../UI/StationElevationPlot";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultView from "../../V2/ResultView";

export function B27({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {
    return (
        <>
            <StationElevationPlot
                crossSection={riverStation?.cross_section}
                plotData={{
                    base: riverStation?.plot_base,
                }}
                globalVariables={globalVariables}
                layers={layers}
            />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.CXWSEL01.error_id: {
            return (
                <>
                    <ResultText>
                        There are crossing WSEL profiles at the following {row?.length} cross sections listed below. Profiles crossing more than {settings?.thresholds?.crossing_default} ft are highlighted in red text.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start', verticalAlign: 'top'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(35), textAlign: 'start', verticalAlign: 'top'}}>Crossing Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start', verticalAlign: 'top'}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{
                                            width: HecRasHelper.getWidth(35),
                                            textAlign: 'end',
                                            verticalAlign: 'top'
                                        }}>
                                            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                                {
                                                    r.profiles?.map((p, idx) => (
                                                        <span>
                                                            <span style={{color: p.crossing < -1 * (settings?.thresholds?.crossing_default) ? 'red' : ''}}>{p.profile}</span>
                                                            {idx < r.profiles.length-1 && <>,&nbsp;</>}
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.B27_NOOUT01.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B27_NOOUT02.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
    }
}